import React, { useState, useEffect } from 'react';
import * as S from './styles';

const ModalSelecionarProduto = ({ isOpen, onClose, produtos = [], onSelecionar }) => {
  const [selecionados, setSelecionados] = useState([]);

  useEffect(() => {
    if (!isOpen) {
      setSelecionados([]); // limpa quando o modal for fechado
    }
  }, [isOpen]);

  const toggleProduto = (produto) => {
    if (selecionados.some(p => p._id === produto._id)) {
      setSelecionados(selecionados.filter(p => p._id !== produto._id));
    } else {
      setSelecionados([...selecionados, produto]);
    }
  };

  const selecionarTodos = () => {
    if (selecionados.length === produtos.length) {
      setSelecionados([]);
    } else {
      setSelecionados(produtos);
    }
  };

  const handleConfirmar = () => {
    onSelecionar(selecionados);
    setSelecionados([]);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <S.Overlay>
      <S.ModalContainer>
        <S.Title>Selecionar Produtos</S.Title>
        {produtos.length === 0 ? (
          <p>Nenhum produto disponível.</p>
        ) : (
          <>
            <S.ButtonGroup style={{ justifyContent: 'flex-start', marginBottom: '10px' }}>
              <S.SmallButton onClick={selecionarTodos}>
                {selecionados.length === produtos.length ? 'Desmarcar Todos' : 'Selecionar Todos'}
              </S.SmallButton>
            </S.ButtonGroup>
            <S.StyledTable>
              <thead>
                <tr>
                  <th>GTIN</th>
                  <th>Marca</th>
                  <th>Descrição</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {produtos.map((produto) => (
                  <tr key={produto._id}>
                     <td>{produto.gtin}</td>
                          <td>{produto.marca}</td>
                          <td>{produto.descricao}</td>
                    <td>
                      <S.SmallButton onClick={() => toggleProduto(produto)}>
                        {selecionados.some(p => p._id === produto._id) ? 'Remover' : 'Selecionar'}
                      </S.SmallButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </S.StyledTable>
          </>
        )}
        <S.ButtonGroup>
          <S.Button onClick={handleConfirmar} disabled={selecionados.length === 0}>
            Confirmar Seleção
          </S.Button>
          <S.CancelButton onClick={onClose}>Cancelar</S.CancelButton>
        </S.ButtonGroup>
      </S.ModalContainer>
    </S.Overlay>
  );
};

export default ModalSelecionarProduto;
